module.exports = __webpack_public_path__ + "static/media/reply.9ef272af.svg";